export default __webpack_public_path__ + "static/media/dealership.6a08861e.svg";